import { setRequirement } from "features/common/layouts/cartSlice";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

const ToSCompanyCheckBox = () => {
  const dispatch = useDispatch();
  const { requirement, orderProcessName } = useSelector((state) => state.cart);

  const checkHandler = (e) => {
    const requirement = e.target;

    if (requirement.id === "tos") {
      dispatch(
        setRequirement({
          tos: requirement.checked && requirement.id === "tos" ? true : false,
        })
      );
    }

    if (requirement.id === "company") {
      dispatch(
        setRequirement({
          company:
            requirement.checked && requirement.id === "company" ? true : false,
        })
      );
    }

    if (requirement.id === "pph" && orderProcessName !== "domain") {
      dispatch(
        setRequirement({
          pph: requirement.checked && requirement.id === "pph" ? true : false,
        })
      );
    }
  };

  return (
    <div className="py-3">
      {/* <div className="form-check mb-3">
        <input
          type="checkbox"
          className="form-check-input"
          name="internet"
          id="internet"
          value="internet"
          onChange={() => setIsInternetChecked(!isInternetChecked)}
          checked={isInternetChecked}
        />
        <label
          htmlFor="internet"
          className="ms-3 form-check-label"
          style={{ fontSize: "14px" }}
        >
          Saya bersedia untuk mendapatkan penawaran Internet Qwords
        </label>
      </div> */}
      <div className="form-check mb-3">
        <input
          type="checkbox"
          className="form-check-input"
          name="company"
          id="company"
          value="company"
          onChange={checkHandler}
          checked={requirement.company}
        />
        <label
          htmlFor="company"
          className="ms-3 form-check-label"
          style={{ fontSize: "14px" }}
        >
          Saya adalah Perusahaan dan Membutuhkan Faktur Pajak (Opsional)
        </label>
      </div>
      {/* {orderProcessName === 'domain' || orderProcessName === 'domainBackorder' ? '' : 
			<div className="form-check mb-3">
				<input
					type="checkbox"
					className="form-check-input"
					name="pph"
					id="pph"
					value="pph"
					onChange={checkHandler}
					checked={requirement.pph}
				/>
				<label htmlFor="pph" className="ms-3 form-check-label" style={{ fontSize: "14px" }}>
					Saya adalah Perusahaan dan Membutuhkan Pemotongan Pph 23 (Opsional)
				</label>
			</div>
			} */}

      <div className="form-check mb-3">
        <input
          type="checkbox"
          className="form-check-input"
          name="tos"
          id="tos"
          value="tos"
          onChange={checkHandler}
          checked={requirement.tos}
        />
        <label
          htmlFor="tos"
          className="ms-3 form-check-label"
          style={{ fontSize: "14px" }}
        >
          Saya telah membaca dan menyetujui{" "}
          <a
            className="text-decoration-none"
            href={`${process.env.REACT_APP_QWORDS_API}master-service-agreement/?tab-content=terms-of-service`}
            target="_blank"
            rel="noreferrer"
          >
            <span className="text-qw-primary fw-bold">Term of Service</span>
          </a>
        </label>
      </div>
    </div>
  );
};

export default ToSCompanyCheckBox;
